import script from "./ProfessionalTitleForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfessionalTitleForm.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__